module.exports = __webpack_public_path__ + "img/93c1be3c1e2d04912112cccbb8a1acad.png";